<template>
    <!-- App -->
    <div id="app">
        <!-- Statusbar -->
        <f7-statusbar></f7-statusbar>

        <!-- Main View -->
        <f7-view id="main-view" url="/" main :pushState="true">
        </f7-view>
    </div>
</template>


<script>
    const oAuthUrl = "https://oauth.thu.edu.tw/v1/index.php";
    const axiosUrl = "https://thucoin.thu.edu.tw:5000";
    const cdnUrl = "https://thucoin.thu.edu.tw:5000/cdn";
    export default {
        oAuthUrl,
        axiosUrl,
        cdnUrl,
        data() {
            return {
                pushState:true
            }
        },
        created() {
            
        },mounted() {
            
        },
    }
</script>



// WEBPACK FOOTER //
// src/app.vue